import React from 'react';
import PropTypes from 'prop-types';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

ProgressIndicator.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    stepIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  })).isRequired,
  activeStepId: PropTypes.string.isRequired,
  completedStepIds: PropTypes.arrayOf(PropTypes.string),
};

export default function ProgressIndicator(props) {
  const { steps, activeStepId, completedStepIds = [] } = props;
  return (
    <div className="flex flex-col md:flex-row gap-3 lg:gap-8 items-start lg:items-center w-full">
      {steps.map((step) => {
        const isActive   = step.stepIds.includes(activeStepId);
        const isComplete = !isActive && step.stepIds.some(id => completedStepIds.includes(id));

        return (
          <div key={step.id} className="flex flex-col flex-1">
            <div className="relative w-full h-3 rounded bg-gray-200 hidden md:block">
              {isComplete && (
                <div className="absolute inset-0 bg-cs-blue-500 rounded" />
              )}
            </div>
            <div className="flex flex-row items-center gap-1 mt-2">
              {isComplete && (
                <CheckCircleIcon className="size-6 text-cs-blue-500 flex-shrink-0" />
              )}
              {isActive && (
                <div className="w-[22px] h-[22px] rounded-full border-2 border-cs-blue-500 bg-white flex-shrink-0" />
              )}
              {!isComplete && !isActive && (
                <div className="w-[22px] h-[22px] rounded-full border-2 border-gray-300 bg-white flex-shrink-0" />
              )}
              <span className={`text-base leading-[1.5] flex-1 ${
                isActive   ? 'font-semibold text-cs-gray-900'
                : isComplete ? 'font-normal text-cs-gray-500'
                : 'font-normal text-cs-gray-500'
              }`}>
                {step.label}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
